<script setup>
import { computed } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: "#000000",
  },
});

const loaderStyle = computed(() => ({
  '--loader-color': props.color,
  '--_m': `conic-gradient(#0000 1%, #000), linear-gradient(#000 0 0) content-box`,
  'background': props.color
}));
</script>

<template>
<div 
  class="standard-button-loader"
  :style="loaderStyle"
></div>
</template>

<style scoped>

.standard-button-loader {
  width: 20px;
  height: 20px; /* Ensure height is set to maintain the aspect ratio */
  padding: 2px;
  border-radius: 50%;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1.2s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(-1turn);
  }
}
</style>